export const contextMenuSx = {
  '& .MuiListItemIcon-root': {
    minWidth: 'auto !important',
    paddingRight: 1.5,
    '& .MuiSvgIcon-root': {
      color: 'text.secondary',
      width: 18,
      height: 18
    }
  },
  '& .MuiMenuItem-root': {
    fontSize: 13,
    paddingRight: 3
  }
};
